import FetchFeedback from "../ui/CustomFetchFeedback/CustomFetchFeedback";
import useMerchantData from "./hooks/useMerchantData";
import useMerchantReferenceData from "./hooks/useMerchantReferenceData";
import ManageMerchantContent from "./ManageMerchantContent";

const ManageMerchant = () => {
  const { merchants, isLoading, isError, refetch, noMerchants } =
    useMerchantData();
  const referenceDataHook = useMerchantReferenceData();

  if (isError) {
    return (
      <FetchFeedback
        message="Failed to load merchants. Please try again."
        onRetry={refetch}
      />
    );
  }

  return (
    <ManageMerchantContent
      merchants={merchants}
      loadingData={isLoading}
      noMerchants={noMerchants}
      referenceDataHook={referenceDataHook}
    />
  );
};

export default ManageMerchant;
